// AXIOS
import axios from "axios";

// api url
import { apiToken, apiUrl_forCart } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// save to cart
export let cancelSaveToCartApi;
export async function saveToCart(token, data) {
    if (data) {
        const cartData = await axios.post(
            apiUrl_forCart,
            {
                // temp_order_id: data.temp_order_id,
                // product_id: data.product_id,
                // quantity: data.quantity,
                // mode: "add",

                customer_id: data.customer_id,
                mode: data.mode,
                product_id: data.product_id,
                quantity: data.quantity,
                temp_order_id: data.temp_order_id,
                variant_sku: data.variant_sku,
            },
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelSaveToCartApi = c;
                }),
            }
        );
        return cartData;
    } else {
        console.log("Please add required parameters");
    }
}

// get cart item
export let cancelGetCartItemsApi;
export async function getCartItems(userToken, tempOrderId) {
    if (tempOrderId) {
        const cartData = await axios.get(
            apiUrl_forCart + "?temp_order_id=" + tempOrderId,
            {
                headers: {
                    Authorization: `Bearer ${userToken ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCartItemsApi = c;
                }),
            }
        );
        return cartData;
    } else {
        console.log("Please add required parameters");
    }
}

// delte cart item
export let cancelDeleteCartItemApi;
export async function deleteCartItem(token, data) {
    if (data) {
        const cartData = await axios.delete(
            apiUrl_forCart + data.cart_id + "/" + data.temp_order_id,
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteCartItemApi = c;
                }),
            }
        );
        return cartData;
    } else {
        console.log("Please add required parameters");
    }
}

// delte cart item
export let cancelEmptyCartItemsApi;
export async function emptyCartItems(token, tempUserId) {
    if (tempUserId) {
        const cartData = await axios.delete(
            apiUrl_forCart + "empty/" + tempUserId,
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEmptyCartItemsApi = c;
                }),
            }
        );
        return cartData;
    } else {
        console.log("Please add required parameters");
    }
}

// save to cart
export let cancelMergeCartApi;
export async function mergeCartItems(token, { customerId, from, to }) {
    if (from !== "" && customerId !== "") {
        const cartData = await axios.put(
            apiUrl_forCart + "merge",
            {
                customer_id: customerId,
                from_temp_order_id: from,
                to_temp_order_id: to,
            },
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelMergeCartApi = c;
                }),
            }
        );
        return cartData;
    } else {
        console.log("Please add required parameters");
    }
}

// save to cart
export let cancelCreateOrderApi;
export async function createOrder(token, data) {
    if (data) {
        const cartData = await axios.post(
            apiUrl_forCart + "create/order",
            { ...data },
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelCreateOrderApi = c;
                }),
            }
        );
        return cartData;
    } else {
        console.log("Please add required parameters");
    }
}

// add coupon
export let cancelCheckCoupon;
export async function checkCoupon(
    token,
    { tempOrderId, couponCode, customerId }
) {
    if (couponCode !== "" && tempOrderId !== "") {
        const cartData = await axios.put(
            apiUrl_forCart + "apply/coupon",
            {
                temp_order_id: tempOrderId,
                customer_id: customerId,
                coupon_code: couponCode,
            },
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelCheckCoupon = c;
                }),
            }
        );
        return cartData;
    } else {
        console.log("Please add required parameters");
    }
}

// remove coupon
export let cancelRemoveCoupon;
export async function removeCoupon(token, tempOrderId) {
    if (tempOrderId) {
        const cartData = await axios.put(
            apiUrl_forCart + "remove/coupon",
            {
                temp_order_id: tempOrderId,
            },
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelRemoveCoupon = c;
                }),
            }
        );
        return cartData;
    } else {
        console.log("Please add required parameters");
    }
}

// update guest email
export let cancelUpdateGuestEmailApi;
export async function updateGuestEmail(commonToken, { temp_order_id, email }) {
    if (temp_order_id && email) {
        const cartData = await axios.put(
            apiUrl_forCart + "update/guest/email",
            {
                temp_order_id,
                email,
            },
            {
                headers: {
                    Authorization: `Bearer ${commonToken ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelUpdateGuestEmailApi = c;
                }),
            }
        );
        return cartData;
    } else {
        console.log("Please add required parameters");
    }
}

// update guest email
export let cancelUpdateGuestAddressApi;
export async function updateGuestAddress(
    commonToken,
    { temp_order_id, address }
) {
    if (temp_order_id && address) {
        const cartData = await axios.put(
            apiUrl_forCart + "update/guest/address",
            {
                temp_order_id,
                address,
            },
            {
                headers: {
                    Authorization: `Bearer ${commonToken ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelUpdateGuestAddressApi = c;
                }),
            }
        );
        return cartData;
    } else {
        console.log("Please add required parameters");
    }
}


// charge order payment
export let cancelChargeOrderPaymentApi;
export async function chargeOrderPaymentApi({ order_id, stripe_token, shipping_person, billing_person }) {
    if (order_id && stripe_token) {
        const cart = await axios.put(
            apiUrl_forCart + "charge/payment/" + order_id,
            { stripe_token, shipping_person, billing_person },
            {
                headers: {
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelChargeOrderPaymentApi = c;
                }),
            }
        );
        return cart;
    } else {
        console.log("Please add required parameters");
    }
}